/*
*
* File JS componente Booking
*
*/

// LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import { DateRangePicker,Datepicker} from 'vanillajs-datepicker';
import it from '../../../node_modules/vanillajs-datepicker/js/i18n/locales/it.js';


// https://mymth.github.io/vanillajs-datepicker/#/i18n
// Import the ones you need (it) and merge them with Datepicker.locales
Object.assign(Datepicker.locales, it); 

const current_language = document.documentElement.lang;


//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './booking.scss';

//--------------------------------------------------------------------//

// Funzioni COMPONENTE
//--------------------------------------------------------------------//

const bookingEl = document.querySelector('.booking');
const bookingToggle = document.querySelector('.booking__toggle');
let bookingOffsetTop = bookingEl ? bookingEl.offsetTop : null;


const initDatepicker = () => {


    
    const elem = document.getElementById('booking-date-range');
    const inputArrival = elem.querySelector('.arrival');
    const inputDeparture = elem.querySelector('.departure');

    const iconLeft = '<div class="submenu-indicator"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-open-down"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#ico_prev"></use></svg></div>';

    const iconRight = '<div class="submenu-indicator"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-open-down"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#ico_next"></use></svg></div>';

    const rangepicker = new DateRangePicker(elem, {
        autohide: true,
        format: 'dd/mm/yyyy',
        minDate: new Date(),
        maxDate: new Date().setFullYear(new Date().getFullYear() + 1),
        maxView: 0,
        inputs: [inputArrival, inputDeparture],
        prevArrow: iconLeft,
        nextArrow: iconRight,
        language: current_language,

    });

    inputArrival.addEventListener('changeDate', function () {
        const dates = rangepicker.getDates(); 
        const startDate = dates[0];
        const endDate = dates[1];

        if (startDate) {
            let newEndDate;

            if (!endDate || (endDate && endDate.getTime && endDate.getTime() === startDate.getTime())) {
                
                newEndDate = new Date(startDate);
                newEndDate.setDate(startDate.getDate() + 1);
                
                rangepicker.setDates(startDate, newEndDate);
            }
        }
    });
};



// const initDatepicker = () => {
//     const elem = document.getElementById('booking-date-range');
//     const inputArrival = elem.querySelector('.arrival');
//     const inputDeparture = elem.querySelector('.departure');

//     const iconLeft = '<div class="submenu-indicator"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-open-down"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#ico_prev"></use></svg></div>';

//     const iconRight = '<div class="submenu-indicator"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-open-down"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#ico_next"></use></svg></div>';

//     const rangepicker = new DateRangePicker(elem, {
//         autohide: true,
//         format: 'dd/mm/yyyy',
//         minDate: new Date(),
//         maxDate: new Date().setFullYear(new Date().getFullYear() + 1), 
//         maxView: 0,
//         inputs: [inputArrival, inputDeparture],
//         prevArrow: iconLeft,
//         nextArrow: iconRight,
//     }); 

//     inputArrival.addEventListener('changeDate', (evt) => {
//         let strFormatted = evt.target.value;

//         const [day, month, year] = strFormatted.split('/');

//         let newStrDate = year + '-' + month + '-' + day;

//         let minDate = new Date(newStrDate).setDate(new Date(newStrDate).getDate() + 1);

//         let minDateformat = new Date(minDate).toLocaleDateString('it-it', {
//             year: 'numeric',
//             month: 'numeric',
//             day: 'numeric',
//         });

//         inputDeparture.value = minDateformat;
//         rangepicker.setDates(new Date(newStrDate), new Date(minDate));
//     });
// }

const scrollDetectBooking = () => {
    let headerHeight = 60;
    let currentScroll = window.pageYOffset;

    if ((currentScroll + headerHeight) > bookingOffsetTop)
    {
        bookingEl.classList.add('sticky');
    }
    else
    {
        bookingEl.classList.remove('sticky');
    }
}

const manageMobile = () => {
    bookingToggle.addEventListener('click', (evt) => {
        evt.preventDefault();

        if (bookingEl.classList.contains('open-mobile'))
        {
            bookingEl.classList.remove('open-mobile');
            bookingToggle.classList.remove('open');
        }
        else
        {
            bookingEl.classList.add('open-mobile');
            bookingToggle.classList.add('open');
        }
    });
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const booking = () => {

    if (!bookingEl) return;

    initDatepicker();
    scrollDetectBooking();
    manageMobile();

    window.addEventListener('scroll', scrollDetectBooking);

}

export default booking;

//--------------------------------------------------------------------//